<div class="card">
    <div class="card-header">
        EFSR File Download
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-1 px-1">
                <label class="Label">Date<span class="text-danger">*</span></label>
            </div>
            <div class="col-md-3 px-1">
                <div class="input-group">
                    <input class="form-control" name="HolidayDate" placeholder="Ex. DD/MMM/YYYY"
                        [(ngModel)]="DateSelect" #HolidayDate="ngModel" ngbDatepicker #d="ngbDatepicker"
                        [ngModelOptions]="{standalone: true}" (ngModelChange)="blank()" required readonly />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                        type="button"></button>
                    <div class="invalid-feedback">
                        Please enter date !
                    </div>
                </div>
            </div>
            <div class="col-md-3 px-1">
                <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Search()"><i
                        class="bi bi-search" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}</button>
            </div>
        </div>
        <div class="row m-1">
            <button type="button" class="btn btn-link" [disabled]="isDisabled" (click)="Load('In')">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                *ngIf="isDisabled"></span>
                {{CheckIn}}</button>
            <button type="button" class="btn btn-link" [disabled]="isDisabled" (click)="Load('Out')">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                *ngIf="isDisabled"></span>
                {{CheckOut}}</button>
        </div>
    </div>
</div>